import { Collapse } from "antd";
import React from "react";
import styles from "./objectViewer.module.css";

const { Panel } = Collapse;

const object = {
  tata: {
    a: {
      a_1: ["a", "b", { c: "c" }],
      a_2: "message",
    },
  },
  toto: {
    kk: "string",
    ll: 1,
  },
};

const ObjectViewer = ({ object, title }) => {
  const nestedObjectDisplay = function (data) {
    switch (typeof data) {
      case "object":
        if (data) {
          return Object.keys(data).map((key) => {
            return (
              <Collapse className={styles.object_collapse} key={key}>
                <Panel header={key} key={key}>
                  {data[key] ? nestedObjectDisplay(data[key]) : data[key]}
                </Panel>
              </Collapse>
            );
          });
        }
        break;
      default:
        try {
          return (
            <Panel header={data} key={data}>
              <p>{data}</p>
            </Panel>
          );
        } catch (e) {
          return (
            <Panel header={data} key={data}>
              <p>{JSON.stringify(data)}</p>
            </Panel>
          );
        }
    }
  };

  return (
    <div className={styles.container}>
      <Collapse className={styles.object_collapse}>
        <Panel header={title || "Object Viewer"} key="object_viewer">
          {nestedObjectDisplay(object)}
        </Panel>
      </Collapse>
    </div>
  );
};

export default ObjectViewer;
